export enum ServiceTypeTitles {
  GeneralServices = 'General Services',
  PeopleServices = 'People Services',
}
